import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Input from "../../components/Input";
import Button from "../../components/Button";
import { userLogin } from "../../services/authService";
import { Container, Form, ErrorMessage, Logo } from "./LoginStyles";
import { setUser } from "../../stores/UserStore/UserStore";
import { getStationByCode } from "../../services/stationsService";
import {
  persistRefreshToken,
  persistStation,
  persistStationId,
  persistToken,
} from "../../utils/authMethods";

const Login: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    setLoading(true);
    e.preventDefault();
    try {
      const user = await userLogin(login, password);

      const { full_name, station, token, refresh_token, role } = user;

      persistToken(token);
      persistRefreshToken(refresh_token);
      persistStation(station);

      // O login só devolve o código do posto; buscamos o id para as telas que
      // filtram por ele. Falha aqui não deve impedir o login.
      if (station) {
        try {
          const { id } = await getStationByCode(station);
          persistStationId(id);
        } catch {
          // getStationByCode já registra o erro; a tela de destino tenta de novo.
        }
      }

      setUser({ username: full_name, station, token, role });

      navigate("/redirect");
    } catch {
      setError("Não foi possível autenticar. Verifique suas credenciais.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <Logo
        src={require("../../assets/images/logo-super-ducha.png")}
        alt="Zandoná"
      />
      <Form onSubmit={handleLogin}>
        <h3>Entre com suas credenciais</h3>
        <Input
          type="text"
          label="Usuário"
          value={login}
          onChange={(e) => setLogin(e.target.value)}
          required
        />
        <Input
          type="password"
          label="Senha"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        {error && <ErrorMessage>{error}</ErrorMessage>}
        <Button
          title="Entrar"
          onClick={(e) => handleLogin(e)}
          style={{ marginTop: "10vh" }}
          loading={loading}
        />
      </Form>
    </Container>
  );
};

export default Login;
